import { format } from "date-fns";
import { IOrderGoItem } from "../types/list";
import { ORDER_AKPACA_TYPE, OrderAkpacaTypeValue } from "../../../../../generic/ui/Selectors/OrderAkpacaTypeSelector";
import { readSessionNumber } from "../../../../../generic/utils/warehouseDefaults";

export { getDefaultWarehouseID } from "../../../../../generic/utils/warehouseDefaults";

/** Warehouse chosen in this session; until one is chosen — `defaultTranzitID` (the user's transit). */
export const getTranzitIDFromSessionStorage = (defaultTranzitID = 0) =>
    readSessionNumber('selectedTransitLikut', defaultTranzitID)

export const calcEndDay = () => {
    let date = new Date();
    let endDate = date.setDate(date.getDate() + 7);
    let final = format(endDate, "yyyyMMdd")
    return final
}

export const filterOrdersByType = (
    orders: IOrderGoItem[],
    type: OrderAkpacaTypeValue,
): IOrderGoItem[] =>
    type === ORDER_AKPACA_TYPE.ALL ? orders : orders.filter((order) => order.Type === type)

export interface ILikutActiveFiltersInput {
    isWarehouseFilterVisible: boolean
    tranzitID: number
    typeFilter: OrderAkpacaTypeValue
}

/** Active filters shown on the filter chip; a hidden warehouse field never counts. */
export const countActiveLikutFilters = ({
    isWarehouseFilterVisible,
    tranzitID,
    typeFilter,
}: ILikutActiveFiltersInput): number =>
    (isWarehouseFilterVisible && tranzitID !== 0 ? 1 : 0) +
    (typeFilter !== ORDER_AKPACA_TYPE.ALL ? 1 : 0)

/** 0 — all orders (same reference); otherwise only orders of that warehouse. */
export const filterOrdersByWarehouse = <T extends { WarehouseID?: number | null }>(
    orders: T[],
    warehouseID: number,
): T[] =>
    warehouseID === 0 ? orders : orders.filter((order) => order.WarehouseID === warehouseID)
